export default __webpack_public_path__ + "static/media/STRIP-LogoBGVer.d3972096.png";